import { create } from 'zustand';

export const useNotesStore = create((set) => ({
  isOpen: false,
  payload: null,
  openNotes: (payload) => set({ isOpen: true, payload }),
  close: () => set({ isOpen: false, payload: null }),
}));